import React from "react";

export const ban = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM10.0538 34.1577C9.77544 32.8154 9.62917 31.4248 9.62917 30C9.62917 18.7495 18.7495 9.62917 30 9.62917C36.0339 9.62917 41.4552 12.2526 45.1852 16.4211L10.0538 34.1577ZM15.3508 44.1553C19.0548 47.9878 24.2491 50.3708 30 50.3708C41.2505 50.3708 50.3708 41.2505 50.3708 30C50.3708 28.8472 50.2751 27.7167 50.0911 26.6161L15.3508 44.1553Z"
        fill="currentColor"
      />
    </svg>
  );
};
